export default __webpack_public_path__ + "static/media/monero-xmr-logo.7cf5a54a.svg";